/**
 * Input form field component.
 *
 * Renders either a textarea or input field based on props.
 * Used in the listing form for description and price inputs.
 *
 * @param {Object} props - Component props
 * @param {string|number} props.id - Form field identifier
 * @param {boolean} props.textArea - If true, renders textarea; otherwise input
 * @param {string} props.PlaceHolder - Placeholder text
 * @param {Function} props.onChangeHandler - Callback with (value, id)
 * @param {string} props.type - Input type for non-textarea (e.g., "number")
 * @returns {React.ReactElement} Form input field
 */
function Input({id, textArea , PlaceHolder, onChangeHandler, type}){

  return(
        <div className="mb-3">
          {textArea ? (
              <textarea
                  className={"input-purple form-control"}
                  name="desc"
                  id={"form_"+id}
                  cols="30"
                  onChange={(event)=>onChangeHandler(event.target.value, id)}
                  placeholder={PlaceHolder} rows="6">
              </textarea>
          ):(
              <input
                  className={"input-purple form-control"}
                  id={"form_"+id}
                  type={type}
                  onChange={(event)=>onChangeHandler(event.target.value, id)}
                  placeholder={PlaceHolder} />
            )
          }
      </div>
  )
}

export default Input
